import React from 'react';
import PropTypes from 'prop-types';

import { SUBSCRIPTION_TYPES } from '../../../constants/subscriptions';

const OrderSummary = ({
  selectedSubscription,
  providers,
  showTitle,
  isMobile,
  showPaymentForm,
}) => {
  const providerCount = providers.length;
  const pricePerProvider = selectedSubscription?.price || 0;
  const subtotal = pricePerProvider * providerCount;
  const total = subtotal;

  return (
    <div className="w-full flex flex-col items-start gap-5 grow shrink-0">
      {/* Header Text */}
      {showTitle && (
        <p className=" lg:text-white text-gray-90 text-sm font-extralight leading-5 self-stretch">
          {`Your credit card will be charged either ${SUBSCRIPTION_TYPES.ANNUAL.displayPrice} yearly for the annual Healthgrades Elevated Profile Subscription or ${SUBSCRIPTION_TYPES.MONTHLY.displayPrice} per month for the monthly subscription, depending on the plan you choose.`}
        </p>
      )}

      {/* Subscription Info */}
      {!isMobile ? (
        <div className="flex items-center gap-3 shrink-0 self-stretch">
          <div className="w-full flex flex-col justify-center items-start grow shrink-0">
            <div className="flex justify-between items-start gap-2.5 shrink-0 self-stretch">
              <span className=" lg:text-white text-gray-90 text-base font-semibold leading-6">
                Elevated Profile -{' '}
                {selectedSubscription
                  ? selectedSubscription.id === 'annual'
                    ? 'Annual'
                    : 'Monthly'
                  : ''}
              </span>
              <span className=" lg:text-white text-gray-90 text-base font-semibold leading-6">
                ${subtotal.toFixed(2)}
              </span>
            </div>
            <span className=" lg:text-white text-gray-90 text-sm font-extralight leading-5 self-stretch">
              Qty: {providerCount || 0}
            </span>
          </div>
        </div>
      ) : (
        showPaymentForm && (
          <div className="flex items-center gap-3 shrink-0 self-stretch">
            <div className="w-full flex flex-col justify-center items-start grow shrink-0">
              <div className="flex justify-between items-start gap-2.5 shrink-0 self-stretch">
                <span className=" lg:text-white text-gray-90 text-base font-semibold leading-6">
                  {selectedSubscription?.label || ''} Details
                </span>
                <span className=" lg:text-white text-gray-90 text-base font-semibold leading-6">
                  ${subtotal.toFixed(2)}
                </span>
              </div>
              <span className=" lg:text-white text-gray-90 text-sm font-extralight leading-5 self-stretch">
                Healthgrades Elevated Profile
              </span>
            </div>
          </div>
        )
      )}

      {/* Separator */}
      {!isMobile && (
        <div className="flex flex-col items-start gap-2.5 py-0.5 self-stretch">
          <div className="w-full h-px bg-gray-60 lg:bg-white self-stretch" />
        </div>
      )}
      {/* Subtotal */}
      {!(showPaymentForm && isMobile) && (
        <div className="flex justify-center items-center gap-2.5 shrink-0 self-stretch">
          <span className=" lg:text-white text-gray-90 grow text-sm font-extralight leading-5">
            Subtotal
          </span>
          <span className=" lg:text-white text-gray-90 text-sm font-bold leading-5">
            ${subtotal.toFixed(2)}
          </span>
        </div>
      )}

      {/* Separator */}
      <div className="flex flex-col items-start gap-2.5 py-0.5 self-stretch">
        <div className="w-full h-px bg-gray-60 lg:bg-white self-stretch" />
      </div>

      {/* Total */}
      <div className="flex justify-center items-center gap-2.5 shrink-0 self-stretch">
        <span className=" lg:text-white text-gray-90 grow text-sm font-extralight leading-5">
          Total due today
        </span>
        <span className=" lg:text-white text-gray-90 text-sm font-bold leading-5">
          ${total.toFixed(2)}
        </span>
      </div>
    </div>
  );
};

OrderSummary.propTypes = {
  selectedSubscription: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    price: PropTypes.number,
  }),
  providers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
};

OrderSummary.defaultProps = {
  providers: [],
};

export default OrderSummary;
